import React from 'react';
import styles from './PagerButton.scss';
import classNames from 'classnames';

export default function PagerButton({label, className, selected, onClick}) {
    const buttonClassName = classNames(styles.pagerButton, className, {
        [styles.pagerButtonSelected]: selected
    });

    return (
        <div className={buttonClassName}
             onClick={onClick}>
            {label}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/PagerButton.jsx